import { API_DEV } from "constants/api";
import { handleAPIResult, header } from "utils";

export const powerbiService = {
  getToken,
};

function getToken() {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  //Génère le token pour power bi
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/token/powerbi", getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
